// Custom Google Maps loader to ensure script tag is injected with async/defer
export function useGmap () {
  const apiKey = 'AIzaSyDyA_hRMq5IZKo9WDWuiGZXv4q4QoZqoJ0'
  const libraries = ['places']

  // load() injects the script with async/defer and resolves when google is ready
  const load = () => new Promise((resolve, reject) => {
    if (typeof window !== 'undefined' && window.google && window.google.maps) {
      return resolve(window.google)
    }

    const existing = document.querySelector('script[data-gmaps]')
    if (existing) {
      existing.addEventListener('load', () => resolve(window.google))
      existing.addEventListener('error', (e) => reject(e))
      return
    }

    const script = document.createElement('script')
    script.setAttribute('data-gmaps', '1')
    script.async = true
    script.defer = true
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=${libraries.join(',')}&v=weekly`
    script.addEventListener('load', () => {
      if (window.google) resolve(window.google)
      else reject(new Error('Google API loaded but window.google is undefined'))
    })
    script.addEventListener('error', (e) => reject(e))
    document.head.appendChild(script)
  })

  return { load }
}
